import { TriangleAlert } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { formatDate, formatDays } from "@/lib/format";
import type { PtoBalanceAnnual } from "@/lib/pto-balance";

interface AnnualBalanceCardProps {
  annual: PtoBalanceAnnual;
}

export function AnnualBalanceCard({ annual }: AnnualBalanceCardProps) {
  const percentUsed =
    annual.allowanceHours > 0 ? (annual.usedHours / annual.allowanceHours) * 100 : 0;
  const clampedPercent = Math.min(100, Math.max(0, percentUsed));

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-base">This Year</CardTitle>
        {annual.atRisk && (
          <Badge variant="warning">
            <TriangleAlert className="h-3.5 w-3.5 mr-1" />
            At risk
          </Badge>
        )}
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          {formatDate(annual.periodStart)} – {formatDate(annual.periodEnd)}
        </p>
        <Progress value={clampedPercent} />
        <div className="grid grid-cols-3 gap-4 text-sm">
          <div>
            <span className="text-muted-foreground">Allowance</span>
            <p className="mt-1">{formatDays(annual.allowanceDays)}</p>
          </div>
          <div>
            <span className="text-muted-foreground">Used</span>
            <p className="mt-1">{formatDays(annual.usedDays)}</p>
          </div>
          <div>
            <span className="text-muted-foreground">Remaining</span>
            <p className="mt-1">{formatDays(annual.remainingDays)}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
